import { ThemeUICSSObject } from 'theme-ui';
import getColorsAndStatesByPath from '../colors/util/getColorsAndStatesByPath';
/* IMPORT HERE */

const radio: ThemeUICSSObject = {
  width: '32px',
  height: '32px',
  input: {
    height: '32px !important',
  },
  ...getColorsAndStatesByPath('form.radio'),
  path: {
    fill: 'inherit',
  },
};

export default radio;
